export const filterRecommendationByTagFilterInOperator = (
  tagsFilterValues: Set<string>,
  resourceTagValue?: string,
) => {
  return resourceTagValue && tagsFilterValues.has(resourceTagValue);
};
